module.exports = __webpack_public_path__ + "images/jlr9194d631667552cdbc918d323b4d5f1b.png";